var map = {
	"./itau/itau-step1.png": 10,
	"./itau/itau-step2.png": 177,
	"./itau/itau-step3.png": 960,
	"./itau/itau-step4.png": 127,
	"./itau/itau-step5.png": 166,
	"./itau/itau-step6.png": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 892;